import { useBrandName } from "../lib/company";

interface BlowfishLogoProps {
  size?: "sm" | "md" | "lg";
  variant?: "dark" | "light";
}

const sizeConfig = {
  sm: { img: "w-7 h-7", text: "text-base" },
  md: { img: "w-9 h-9", text: "text-lg" },
  lg: { img: "w-12 h-12", text: "text-2xl" },
};

export const BlowfishLogo = ({ size = "md", variant = "dark" }: BlowfishLogoProps) => {
  const s = sizeConfig[size];
  const textColor = variant === "light" ? "text-white" : "text-ink";
  // Visual mark stays constant; only the wordmark text reflects the tenant brand.
  const brandName = useBrandName();

  return (
    <div className="flex items-center gap-2">
      <img
        src="/images/pufferfish-logo.png"
        alt={brandName}
        className={`${s.img} rounded-lg`}
      />
      <span className={`font-bold ${s.text} ${textColor}`}>{brandName}</span>
    </div>
  );
};
